import PropTypes from 'prop-types';
import { map as _map } from 'lodash';
import moment from 'moment';
import utils from '../utils';
import MonthDash from './MonthDash';
import YearDash from '../Years/YearDash';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Months = function Months(props) {
  var period = props.period,
      getX = props.getX,
      vertical = props.vertical;
  var periodStart = moment(period.start);
  var periodEnd = moment(period.end);
  var monthsCfg = utils.interval.getMonths(periodStart, periodEnd);
  var yearsCfg = utils.interval.getYears(periodStart, periodEnd);

  var months = _map(monthsCfg, function (month) {
    if (month.month !== '01') {
      var x = getX(month.start);
      return /*#__PURE__*/_jsx(MonthDash, {
        x: x,
        vertical: vertical,
        height: 2
      }, "".concat(month.year, "-").concat(month.month));
    } else {
      return null;
    }
  });

  var years = _map(yearsCfg, function (year) {
    var x = getX(year.start);
    return /*#__PURE__*/_jsx(YearDash, {
      x: x,
      vertical: vertical
    }, year.year);
  });

  return /*#__PURE__*/_jsxs("g", {
    className: 'levels',
    children: [months, years.reverse()]
  });
};

Months.propTypes = {
  period: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string
  }).isRequired,
  getX: PropTypes.func.isRequired,
  dayWidth: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  vertical: PropTypes.bool
};
Months.defaultProps = {
  vertical: false
};
export default Months;